import { render, staticRenderFns } from "./brief_training_report.vue?vue&type=template&id=7845884a&scoped=true"
import script from "./brief_training_report.vue?vue&type=script&lang=js"
export * from "./brief_training_report.vue?vue&type=script&lang=js"
import style0 from "./brief_training_report.vue?vue&type=style&index=0&id=7845884a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7845884a",
  null
  
)

export default component.exports